import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AgentCampaignSelector.css';

function AgentCampaignSelector() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAgentCampaigns();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('agentToken');
    localStorage.removeItem('selectedCampaign');
    window.location.href = '/agent/login';
  };

  const fetchAgentCampaigns = async () => {
    try {
      const token = localStorage.getItem('agentToken');
      
      if (!token) {
        navigate('/agent/login');
        return;
      }

      // Fetch campaigns with stats from API
      const response = await fetch('/api/agent/campaigns', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch campaigns');
      }

      const data = await response.json();
      
      if (!data.campaigns || data.campaigns.length === 0) {
        console.error('No campaigns found for your account');
        setLoading(false);
        return;
      }

      setCampaigns(data.campaigns);
      
      // If only one campaign, redirect directly
      if (data.campaigns.length === 1) {
        handleSelectCampaign(data.campaigns[0].campaignId);
        return;
      }

      setLoading(false);
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      setLoading(false);
    }
  };

  const handleSelectCampaign = (campaignId) => {
    // Store selected campaign
    localStorage.setItem('selectedCampaign', campaignId);
    
    // Force full page reload to agent dashboard
    window.location.href = '/agent';
  };

  if (loading) {
    return (
      <div className="campaign-management">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading campaigns...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="campaign-management">
      <header className="campaign-header">
        <div className="header-content">
          <h1>Select Campaign</h1>
          <p className="subtitle">Choose a campaign to continue</p>
        </div>
        <button onClick={handleLogout} className="btn-create" style={{background: '#e74c3c'}}>
          Logout
        </button>
      </header>

      {campaigns.length === 0 ? (
        <div className="empty-state">
          <p>No campaigns found for your account</p>
        </div>
      ) : (
        <div className="campaign-grid">
          {campaigns.map(campaign => (
            <div key={campaign.campaignId} className="campaign-card">
              <div className="campaign-header-card">
                <h2>{campaign.campaignName || campaign.campaignId.toUpperCase()}</h2>
                <span className="status-badge active">
                  Active
                </span>
              </div>
              
              <p className="campaign-type">{campaign.campaignId.replace(/-/g, ' ').toUpperCase()}</p>
              
              <div className="campaign-stats">
                <div className="stat-row">
                  <div className="stat">
                    <span className="stat-label">Today</span>
                    <span className="stat-value">{campaign.stats?.todaySent || 0}</span>
                  </div>
                  <div className="stat">
                    <span className="stat-label">Yesterday</span>
                    <span className="stat-value">{campaign.stats?.yesterdaySent || 0}</span>
                  </div>
                </div>
                <div className="stat-row">
                  <div className="stat">
                    <span className="stat-label">Remaining</span>
                    <span className="stat-value">{campaign.stats?.totalRemaining || 0}</span>
                  </div>
                  <div className="stat">
                    <span className="stat-label">Total Purchased</span>
                    <span className="stat-value">{campaign.stats?.totalPurchased || 0}</span>
                  </div>
                </div>
              </div>

              <div className="campaign-actions">
                <button 
                  onClick={() => handleSelectCampaign(campaign.campaignId)}
                  className="btn-select"
                  style={{width: '100%'}}
                >
                  Select
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AgentCampaignSelector;
